import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import EntityCard from './entity-card';

import styles from './more-entity-card.scss';

const MoreEntityCard = ({
  border,
  deselectAction,
  entity,
  interactive = true,
  moreButton,
  openAction,
  selectAction,
  selected,
  showOutdated
}) => {
  const toggleActive = useCallback(
    () => {
      if (selected) {
        deselectAction();
      } else {
        selectAction();
      }
    },
    [deselectAction, selectAction, selected]
  );

  const onKeyDown = useCallback(event => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      toggleActive();
    }
  }, [toggleActive]);

  const interactiveProps = interactive
    ? { onClick: toggleActive, onKeyDown, role: 'button', tabIndex: 0 }
    : {};

  return (
    <div
      className={classNames(styles.trayCardContainer, {[styles.active]: selected, [styles.border]: border})}
      {...interactiveProps}
    >
      <EntityCard
        entity={entity}
        selected={selected}
        ovViewDetails={openAction}
        embedded
        className={styles.entityCard}
        showOutdated={showOutdated}
      />
      { moreButton &&
        <div className={styles.moreButton}>
          {moreButton}
        </div>
      }
    </div>
  );
};

MoreEntityCard.propTypes = {
  border: PropTypes.bool,
  deselectAction: PropTypes.func,
  entity: PropTypes.object,
  interactive: PropTypes.bool,
  moreButton: PropTypes.object,
  openAction: PropTypes.func,
  selectAction: PropTypes.func,
  selected: PropTypes.bool,
  showOutdated: PropTypes.bool
};

export default MoreEntityCard;
